import * as go from 'gojs';

export const toGoJSKey = (key: string) => {
  const parsedKey = parseInt(key, 10);

  return Number.isNaN(parsedKey) ? key : parsedKey;
};

export const toLayoutKey = (key: go.Key | null) => key?.toString() || '';
